import { httpClient } from '@api';

export default {
  upload: async (payload) => httpClient.post('custom-fields/attachment/upload', payload),
  rename: async (payload) => httpClient.post('custom-fields/attachment/rename', payload),
  delete: async (payload) => httpClient.post('custom-fields/attachment/delete', payload),
  link: async (payload) => httpClient.post('custom-fields/attachment/link', payload),
};
